<div>
	<div class="loading-wrapper">
		<div class="loader"></div>
	</div>
</div>